import {UI} from "../../../../stem-core/src/ui/UIBase";
import {StyleSheet} from "../../../../stem-core/src/ui/Style";

import {MerchantButton} from "../../../common/MerchantButton";
import {styleRule} from "../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {PoweredByBlink} from "../../PoweredByBlink";
import {DONATE_PAGE_URLS} from "../../PaywallConstants";
import {Messages} from "../../../Messages";
import {DonateHomeDonateComponent} from "./DonateHomeDonateComponent";
import {authService, userService} from "../../../../client/connection/Services";
import {StepDescription} from "../StepDescription";
import {donateMobileState} from "../../inline-donation/DonateMobileState";
import {LoadingSpinner} from "../../../ui/LoadingSpinner";
import {PaymentMethodStore} from "../../../State";
import {Link} from "../../../../stem-core/src/ui/UIPrimitives";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService";
import {autoredraw} from "../../../../stem-core/src/decorators/AutoRedraw";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../../../blink-sdk/utils/AnalyticsClient";


class DonateStyle extends StyleSheet {
    @styleRule
    button = {
        ...this.themeProps.DONATE_PAGE_BUTTON,
        marginTop: 20,
    };

    @styleRule
    donateUpdateInfo = this.themeProps.INLINE_DONATE_FLOW_CHECKBOX;

    @styleRule
    center = {
        margin: "20px 0",
        textAlign: "center",
    };

    @styleRule
    link = this.themeProps.DONATE_PAGE_LINK;
}

@autoredraw(iFrameUserDataService)
@registerStyle(DonateStyle)
export class DonatePanel extends UI.Element {
    continueCalled = false;

    render() {
        const {styleSheet} = this;
        StepDescription.stepCount = authService.isAuthenticated() ? 2 : 3;

        return [
            <StepDescription forwardFunction={this.continueCalled ? () => this.continue() : null}
                             currentStep={1} stepDescription={Messages.chooseAmount}/>,
            <DonateHomeDonateComponent onChange={() => this.redraw()}/>,
            <div className={styleSheet.donateUpdateInfo}>{Messages.donateUpdateInfo}</div>,
            <MerchantButton label={donateMobileState.getDonateComponentButtonLabel()}
                            onClick={() => this.continue()} className={styleSheet.button}
                            disabled={!donateMobileState.isValid()}/>,
            authService.isAuthenticated() ? null : <div className={styleSheet.center}>
                <Link className={styleSheet.link} onClick={() => this.continue()}>{Messages.alreadyDonorLogIn}</Link>
            </div>,
            <PoweredByBlink/>,
        ];
    }

    continue() {
        if (!this.continueCalled) {
            dispatchAnalyticsEvent(AnalyticsEventType.DONATE_SELECTED_AMOUNT, {
                amount: donateMobileState.donationAmount,
                frequency: donateMobileState.getFrequency().valueOf(),
                isCustomAmount: donateMobileState.isCustomAmount,
                coversFees: donateMobileState.payDonationFeeCheckboxChecked,
            });
        }
        this.continueCalled = true;
        this.options.changeURL(authService.isAuthenticated() ?
            (PaymentMethodStore.getPrimary() ? DONATE_PAGE_URLS.payWithChosenCard : DONATE_PAGE_URLS.payWithAddedCard)
            : DONATE_PAGE_URLS.auth);
    }

    onMount() {
        super.onMount();
        this.redraw(); // This is for the first rendering where the button doesn't have a label.
        authService.onAuthenticationChange(() => {
            if (this.isInDocument()) {
                if (authService.isAuthenticated()) {
                    LoadingSpinner.show();
                    userService.ensureUserDataRequested(() => {
                        LoadingSpinner.hide();
                        if (iFrameUserDataService.getActiveRecurringDonation()) {
                            this.options.changeURL(DONATE_PAGE_URLS.recurringDonor);
                        } else {
                            this.redraw();
                        }
                    });
                } else {
                    this.redraw();
                }
            }
        });
    }
}
